import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

import { DEFAULT_PAGE_SIZE } from '../../constants/commonConstants';
import { ENV_CONFIG } from 'src/app/core/injection.token';

type DynamicResponse<T> = app.models.DynamicResponse<T>;
type DynamicPaged<T> = app.models.DynamicResponse<app.models.PagedResult<T>>;

@Injectable()
export class PaymentAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'payment';

  public getPagedPayments(pageIndex: number, pageFilter: app.models.GetPagedPaymentsPageFilterModel) {
    let queryParams = {
      startDate: pageFilter.startDate ? pageFilter.startDate.toISOString() : null,
      endDate: pageFilter.endDate ? pageFilter.endDate.toISOString() : null,
      page: pageIndex,
      pageSize: DEFAULT_PAGE_SIZE,
    };

    const request = 'getPagedPayments';
    const url = this._apiService.buildUrl(
      this._envConfig.PORTAL_BACKEND_APISYNC_URL,
      this.controller,
      request,
      queryParams
    );

    return this._apiService.get<DynamicPaged<app.models.GetPagedPaymentsModel>>(url);
  }

  public getPayment(paymentId: string) {
    const request = 'getPayment';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, {
      paymentId: paymentId,
    });

    return this._apiService.get<DynamicResponse<app.models.GetPaymentModel>>(url);
  }

  public getDashboardPaymentsData(startingDate: Date, endingDate: Date) {
    const request = 'getDashboardPayments';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = { startingDate: startingDate, endingDate: endingDate };
    return this._apiService.postAsync<app.models.dashboard.PaymentsDataModel>(url, body, []);
  }
}
